import React from "react";
import { ArrowRightIcon } from "lucide-react";
const PORTRAIT = "https://cdn.magicpatterns.com/patterns/generated-images/3687e5b8-227f-438e-9821-14a3bef18be9.jpg";
const pillars = [{
  label: "Affaires publiques",
  text: "Stratégie, veille et plaidoyer"
}, {
  label: "Relations institutionnelles",
  text: "Parlement, Gouvernement, régulateur"
}, {
  label: "Jeux en ligne",
  text: "Paris sportifs, hippiques et poker"
}];
export function About() {
  return <section id="a-propos" className="bg-white py-24 lg:py-32" data-id="element-4" data-mp="33pf7fthxphkb">
      <div className="mx-auto grid max-w-7xl gap-14 px-6 sm:px-8 lg:grid-cols-12 lg:gap-16" data-id="element-5" data-mp="38oruofcpwqnf">
        <div className="lg:col-span-5" data-id="element-6" data-mp="3dicjbgsf889y">
          <div className="overflow-hidden rounded-2xl bg-sand" data-id="element-7" data-mp="3djfcxwh4ootk">
            <img src={PORTRAIT} alt="Portrait d'Éléonore Para, consultante en affaires publiques" className="aspect-[4/5] w-full object-cover" data-id="element-8" data-mp="3hi4xqa4hx8n8" />
          </div>
        </div>

        <div className="flex flex-col justify-center lg:col-span-7" data-id="element-9" data-mp="3rehn4vt0d0c6">
          <p className="text-[15px] font-medium text-muted" data-id="element-10" data-mp="2lssabod1xax4">À propos</p>
          <h2 className="mt-4 font-display text-4xl font-semibold leading-[1.1] tracking-tight text-ink sm:text-5xl" data-id="element-11" data-mp="2grusjcvyeiw5">
            Un regard d'initiée sur un secteur où chaque décision publique compte.
          </h2>
          <div className="mt-8 space-y-5 text-lg leading-relaxed text-muted" data-id="element-12" data-mp="27sr9ua0p85i6">
            <p data-id="element-13" data-mp="34hyocy2whecl">
              Éléonore Para conseille les entreprises en affaires publiques et relations institutionnelles.
              Elle intervient tout particulièrement auprès des acteurs du jeu en ligne, un secteur
              strictement encadré où la réglementation façonne directement le modèle économique.
            </p>
            <p data-id="element-14" data-mp="2qq1yl0opfgjd">
              Son approche : une connaissance fine des circuits de décision, une parole juste
              et un dialogue transparent avec les institutions. Son activité est référencée
              auprès de la Haute Autorité pour la transparence de la vie publique.
            </p>
          </div>

          <dl className="mt-12 grid gap-8 border-t border-line pt-8 sm:grid-cols-3" data-id="element-15" data-mp="686f4td2gmsz">
            {pillars.map(p => <div key={p.label} data-id="element-16" data-mp="3tj621waenz3w">
                <dt className="font-display text-lg font-semibold text-ink" data-id="element-17" data-mp="3thux3t584lb7">{p.label}</dt>
                <dd className="mt-1.5 text-[15px] text-muted" data-id="element-18" data-mp="1e2706s2e8qb">{p.text}</dd>
              </div>)}
          </dl>

          <a href="#contact" className="mt-12 inline-flex w-fit items-center gap-2 text-[15px] font-semibold text-ink underline decoration-line decoration-2 underline-offset-8 transition-colors duration-150 hover:decoration-ink" data-id="element-19" data-mp="3jj5hk70svcy4">
            Échanger avec Éléonore
            <ArrowRightIcon className="h-4 w-4" data-id="element-20" data-mp="3em5joje3tgi3" />
          </a>
        </div>
      </div>
    </section>;
}